import { Moment } from 'moment-timezone';
import { setDate } from '../../../../functions/date-setter';

/**
 * Lightweight shape for the "Copy from existing entry" dropdown.
 * Returned by GET /organizations/{organizationId}/transactions/journal-entries/past-entries.
 */
export class JournalEntrySummary {
    id: number;
    transactionDate: Moment;
    description: string;
    amount: number;

    constructor(data: any) {
        this.id = data.id;
        this.transactionDate = setDate(data.transactionDate ?? data.transaction_date);
        this.description = data.description ?? '';
        this.amount = data.amount ?? 0;
    }
}
